import { render, staticRenderFns } from "./threePage.vue?vue&type=template&id=a82a2336&scoped=true&"
import script from "./threePage.vue?vue&type=script&lang=js&"
export * from "./threePage.vue?vue&type=script&lang=js&"
import style0 from "./threePage.vue?vue&type=style&index=0&id=a82a2336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82a2336",
  null
  
)

export default component.exports